export default __webpack_public_path__ + "static/media/userboxIcon.cecfab6c.svg";